import styled from 'styled-components';

export const DownwardArrow = styled.div`
    width: 0px;
    height: 0px;
    margin-left: 5px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #FE1040;
`;